import React, { useEffect, useState } from "react";
import { useFileUploadApiMutation } from "../api/apiSlices/reconApi";
import useApiHouse from "../api/useApiHouse";
import { startProcessingFilePayload } from "../api/apiPayloads";
import { useSelector, useDispatch } from "react-redux";
import { uploadStatusCheckPayload } from "../api/apiPayloads";
import useGetFormData from "./useGetFormData";
import { setLoader } from "../slices/loaderSlice";

const useUploadFile = (setOpen, setMsgCallback, setSecondOpen) => {
    const [fileUploadApi, {data: fileUploadData, isLoading: fileUploadLoading, error: fileUploadErr}] = useFileUploadApiMutation();
    const [startProcessingApi, {data: startProcessingData, isLoading: startProcessingLoading, error: startProcessingErr}] = useApiHouse();
    const [checkStatusApi, {data: checkStatusData, isLoading: checkStatusLoading, error: checkStatusErr}] = useApiHouse();
    const {getFormData} = useGetFormData();
    const {currentJob: {shippingId, reconShipmentId}} = useSelector((state) => state.currentJob);

    const dispatch = useDispatch();
    const fileUpload = (file) => {
        dispatch(setLoader({path: "fileUploadLoader", value: true}))
        let bodyFormData = new FormData();
        bodyFormData.append("file", file);
        bodyFormData.append("reconShippingId", shippingId);
        fileUploadApi(bodyFormData);
    }

    useEffect(() => {
        if(!fileUploadLoading && fileUploadData){
            const {fileName} = fileUploadData
            startProcessingApi(startProcessingFilePayload(reconShipmentId, fileName));
        }
        else if(fileUploadErr){
            setMsgCallback({color: "red", message: "Something went Wrong, pls try again later...", title: "Something Went Wrong..."})
        }
    }, [fileUploadData, fileUploadLoading, fileUploadErr])

    useEffect(() => {
        if((!startProcessingLoading && startProcessingData) || startProcessingErr){
            checkStatusApi(uploadStatusCheckPayload(reconShipmentId));
        }
        else if(startProcessingErr){
            setMsgCallback({color: "red", message: "Something went Wrong, pls try again later...", title: "Something Went Wrong..."})
        }
    }, [startProcessingData, startProcessingLoading, startProcessingErr]);
    useEffect(() => {
        if((!checkStatusLoading && checkStatusData)){
            const {isProcessing} = checkStatusData;
            if(isProcessing || checkStatusErr){
                checkStatusApi(uploadStatusCheckPayload(reconShipmentId));
            }
            else{
                dispatch(setLoader({path: "fileUploadLoader", value: false}))
                getFormData();
                setMsgCallback({color: "black", message: "Successfully Uploaded File", title: "File Uploaded"})
                setSecondOpen(true)
            }
        }
        else if(checkStatusErr){
            checkStatusApi(uploadStatusCheckPayload(reconShipmentId));
            setMsgCallback({color: "red", message: "Something went Wrong, pls try again later...", title: "Something Went Wrong..."})
            setSecondOpen(true)
        }
    }, [checkStatusData, checkStatusLoading, checkStatusErr]);

    return { fileUpload, fileUploadLoading, startProcessingLoading, checkStatusLoading };
}
 
export default useUploadFile;